import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Button from '../../sitewide/Button'
import Toggle from 'material-ui/Toggle'
import EmailBodyEditor from '../EmailBodyEditor'
import PlainTextEditor from '../PlainTextEditor'
import characterCountMessage from '../../../services/character-count'

import styles from './styles.css'

class NewAppointmentMessageEditor extends React.Component {
  static propTypes = {
    activateSetting: PropTypes.func,
    deactivateSetting: PropTypes.func,
    handleSave: PropTypes.func,
    isEmail: PropTypes.bool,
    title: PropTypes.string,
    maxChars: PropTypes.number.isRequired,
    setting: PropTypes.shape({
      active: PropTypes.bool.isRequired,
      always_send: PropTypes.bool.isRequired,
      created_at: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      message_setting_type: PropTypes.string.isRequired,
      message_type: PropTypes.string.isRequired,
      offset: PropTypes.number.isRequired,
      practice_id: PropTypes.number.isRequired,
      updated_at: PropTypes.string.isRequired,
    }),
  }

  state = {
    settingToggled: null,
    textChange: false,
  }

  saveMessageSetting = () => {
    const { handleSave } = this.props
    this.setState({ textChange: false })
    handleSave()
  }

  updateTextChange = (newState, oldState) => {
    const { textChange } = this.state
    const sameContent =
      newState.getCurrentContent() === oldState.getCurrentContent()
    if (!sameContent && !textChange) {
      this.setState({ textChange: true })
    }
  }

  subjectUpdate = newEditorState => {
    const { subjectState, updateSubjectState } = this.props
    this.updateTextChange(newEditorState, subjectState)
    updateSubjectState(newEditorState)
  }

  bodyUpdate = newEditorState => {
    const { bodyState, updateBodyState } = this.props
    this.updateTextChange(newEditorState, bodyState)
    updateBodyState(newEditorState)
  }

  handleToggle = () => {
    const { activateSetting, deactivateSetting, setting } = this.props
    const { settingToggled } = this.state
    if (
      (settingToggled === null && setting.active) ||
      settingToggled === true
    ) {
      deactivateSetting(setting.id, { newApptSettingBypass: true })
      this.setState({ settingToggled: false })
    } else {
      activateSetting(setting.id, { newApptSettingBypass: true })
      this.setState({ settingToggled: true })
    }
  }

  render() {
    const { bodyState, subjectState, isEmail, title, maxChars, setting } =
      this.props
    const { settingToggled, textChange } = this.state

    const messageContainerStyles = cx(styles.container, {
      [styles.newAppointmentEmailContainer]: isEmail,
      [styles.newAppointmentTextContainer]: !isEmail,
    })

    const validEmail = isEmail
      ? bodyState.getCurrentContent().hasText() &&
        subjectState.getCurrentContent().hasText()
      : true

    const emptyConfText =
      !isEmail && !bodyState.getCurrentContent().getPlainText().trim()
    const characterCount = bodyState.getCurrentContent().getPlainText().length
    const approachingMaxChars = characterCount > maxChars - 20 && !isEmail
    const exceedsMaxChars = characterCount > maxChars && !isEmail

    const charCountCss = cx(styles.characterCount, {
      [styles.approachingMaxChars]: approachingMaxChars,
      [styles.exceedsMaxChars]: exceedsMaxChars,
    })

    const saveDisabled = !textChange || !validEmail || exceedsMaxChars

    return (
      <div className={`${messageContainerStyles}`}>
        <div className={styles.titleToggleBox}>
          <h3>{title}</h3>
          <Toggle
            id={`newApptMessageSettingToggle-${isEmail ? 'email' : 'text'}`}
            toggled={settingToggled === null ? setting.active : settingToggled}
            label="Enable/Disable"
            style={{ maxWidth: '175px' }}
            onToggle={this.handleToggle}
          />
        </div>
        {(settingToggled === null ? setting.active : settingToggled) && (
          <div className={styles.editorWrapper}>
            {isEmail && (
              <PlainTextEditor
                {...this.props}
                updateSubjectState={this.subjectUpdate}
              />
            )}
            <div className={styles.bodyEditor}>
              {isEmail ? (
                <EmailBodyEditor
                  {...this.props}
                  updateBodyState={this.bodyUpdate}
                />
              ) : (
                <PlainTextEditor
                  {...this.props}
                  updateBodyState={this.bodyUpdate}
                />
              )}
              <div className={styles.buttonWrapper}>
                <Button
                  disabled={saveDisabled}
                  onClick={this.saveMessageSetting}
                  paddingTB="7px"
                  paddingLR="30px"
                >
                  {textChange ? 'Save' : 'Saved'}
                </Button>
                {emptyConfText && (
                  <span className={styles.confirmationNote}>
                    NOTE: A new appointment message will not be sent if this
                    editor is left blank
                  </span>
                )}
              </div>
              {!isEmail && characterCount > 0 && (
                <div className={charCountCss}>
                  {characterCountMessage(characterCount, maxChars)}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default NewAppointmentMessageEditor



// WEBPACK FOOTER //
// ./src/components/Settings/NewAppointmentMessageEditor/NewAppointmentMessage.js